import eventsData from "./../events.json";
import TourCard from "./TourCard";
import EventCard from "./EventCard";
import { useMemo } from "react";

const Inicio = () => {
	const parseEventDate = (dateStr) => {
		const parts = dateStr.split("-");
		const day = parseInt(parts[0]);
		const month = parseInt(parts[1]) - 1;

		let year;
		if (parts[2]) {
			const yearPart = parts[2];
			if (yearPart.length === 2) {
				year = parseInt("20" + yearPart);
			} else {
				year = parseInt(yearPart);
			}
		} else {
			const now = new Date();
			const currentYear = now.getFullYear();
			const currentMonth = now.getMonth();

			if (
				month < currentMonth ||
				(month === currentMonth && day < now.getDate())
			) {
				year = currentYear + 1;
			} else {
				year = currentYear;
			}
		}

		return new Date(year, month, day);
	};

	const sortedItems = useMemo(() => {
		const today = new Date();
		today.setHours(0, 0, 0, 0);
		const cutoff = new Date(today);
		cutoff.setDate(cutoff.getDate() - 2);

		const toursMap = new Map();
		const singles = [];

		eventsData.forEach((event) => {
			if (event.is_gira) {
				if (!toursMap.has(event.band)) {
					toursMap.set(event.band, {
						band: event.band,
						band_name: event.band_name,
						tour_name: event.tour_name,
						flyer_gira: event.flyer_gira,
						events: [],
						isTour: true
					});
				}
				toursMap.get(event.band).events.push(event);
			} else {
				if (parseEventDate(event.date) >= cutoff) {
					singles.push({
						...event,
						isTour: false
					});
				}
			}
		});

		toursMap.forEach((tour) => {
			tour.events = tour.events.filter(
				(e) => parseEventDate(e.date) >= cutoff
			);
			tour.events.sort(
				(a, b) =>
					parseEventDate(a.date) -
					parseEventDate(b.date)
			);
		});

		const tours = Array.from(toursMap.values()).filter(
			(tour) => tour.events.length > 0
		);

		const allItems = [
			...tours.map((tour) => ({
				...tour,
				sortDate: parseEventDate(tour.events[0].date)
			})),
			...singles.map((event) => ({
				...event,
				sortDate: parseEventDate(event.date)
			}))
		];

		return allItems.sort((a, b) => a.sortDate - b.sortDate);
	}, []);

	return (
		<section className='page-section' id='inicio'>
			<div className='container'>
				<div className='row justify-content-center'>
					{sortedItems.map((item, index) =>
						item.isTour ? (
							<TourCard
								key={`tour-${item.band}-${index}`}
								tour={item}
								events={
									item.events
								}
							/>
						) : (
							<EventCard
								key={`event-${index}`}
								event={item}
							/>
						)
					)}
				</div>
			</div>
		</section>
	);
};

export default Inicio;
